import { ReactElement } from 'react'
import illustration from '../images/Padasjoki4.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Yritän valua alemmas penkissäni, etteivät kaverini huomaisi minua. Tämä on niin noloa!',
    gotoStage: 0
  },
  {
    text: 'Kannustan isääni loppuun asti ja taputan muun yleisön mukana. Ei sillä ole väliä, mitä muut ajattelevat.',
    gotoStage: 5
  },
  {
    text: 'Pakenen paikalta ja äkkiä.',
    gotoStage: 0
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const PadasjokiStage4 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle small>Säärikilpailun lumoa</StageTitle>
      <StageText>
        Tehtaan pillin vislaus vaihtui torvensoittoon, kun sahan oma torvisoittokunta siirtyi nuorisoseurantalo Ahjolan lavalle ottaen paikkansa orkesterina. ”Minne isä meni?” kuiskaat vieressäsi istuvalle äidillesi, joka naurahtaa: ”Kohta näet”. Lavalla joku kertoo pitkäveteisiä alkusanoja. Katseesi vaeltelee salissa ja näet lavan verhojen välissä vilahtavan jotakin vaaleanpunaista.
      </StageText>
      <StageText>
        Äitisi tökkää sinua hellästi kyynärpäällään: ”Kuuntele nyt tarkkaan, kohta se alkaa.” Keskität katseesi lavalla puhettaan jatkavaan juontajaan. ”…ja pidemmittä puheitta, kuten perinteeseen kuuluu, toivotamme lämpimästi tervetulleeksi kaikki tämän vuoden Säärikilpailun kilpailijat! Olemme tänäkin vuonna saaneet mukaan uuden tulokkaan, joten antakaahan raikuvat aplodit illan ensimmäiselle kilpailijalle; tervetuloa lavalle Jukkastiina!”
      </StageText>
      <StageText>
        Leukasi tipahtaa lattiaan, kun näet isäsi astelevan balettiasussa verhoista lavalle. Hän nostaa kätensä ilmaan ja nyökkää orkesterille, joka alkaa säestämään esitystä. Isäsi liikkuminen on vähintäänkin kankeaa, mutta hän on selvästi perehtynyt balettiaskeliin ja toistaa opeteltua sarjaa mekaanisesti totisen näköisenä. Yleisö taputtaa ja kannustaa häntä villisti. Tunnet taas naurun poreilevan vatsasi pohjassa, tämä on huvittavin näky ikinä. Näet ystäviesi vilkuilevan sinun suuntaasi yleisössä ja naureskelevan keskenään.
      </StageText>
      <StageText>
        <strong>Mitä teet?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default PadasjokiStage4
